<template>
  <iframe class="questions" src="http://61.220.29.158:9000/ruishishu/subjects" frameborder="0"></iframe>
</template>

<script>
export default {
  components: {
  }
};
</script>

<style lang="stylus" scoped>

.questions {
  width: 100%;
  height: 100%;
}
</style>


